import React from "react";
import { useParams } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { MdAddComment } from "react-icons/md";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import encryptionModule from "../../components/common/localStorageUtils";
import axios from "axios";
import { IoCloseSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const EditCoursePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  //   Cloudinary info
  const cloudName = "dnw1ttr02";
  const upload_preset = "wjs1zyo5";
  const adminData = encryptionModule.decryptData("adminInfo");
  const AdminId = adminData?.user?._id;
  console.log(adminData);

  //Variables declared here...
  const { register, handleSubmit } = useForm();
  const [load, setload] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [keyPoints, setKeyPoints] = useState("");
  const [keyPointArr, setKeyPointArr] = useState([]);
  const [chooseCourse, setChooseCourse] = useState("");
  const [chooseCourseArr, setChooseCourseArr] = useState([]);
  const [courseImg, setCourseImg] = useState([]);
  const [arrOfCourseImg, setArrOfCourseImg] = useState([]);
  const [category, setCategory] = useState([]);
  const [courseBannerImg, setCourseBannerImg] = useState("");
  const [imageOne, setImageOne] = useState("");
  const [imageTwo, setImageTwo] = useState("");
  const [loadingBnr, setLoadingBnr] = useState(false);
  const [loadImageOne, setLoadImageOne] = useState(false);
  const [loadImageTwo, setLoadImageTwo] = useState(false);
  const [loaderOne, setloaderOne] = useState(false);
  const [loaderTwo, setloaderTwo] = useState(false);
  const [loaderThree, setloaderThree] = useState(false);
  const [currentCourse, setCurrentCourse] = useState({});
  //About Course Key Points are Handled...
  const handleKeyPointsChange = () => {
    let arr = [...keyPointArr];
    arr.push(keyPoints);
    setKeyPointArr(arr);
    setKeyPoints("");
  };
  //Why Choose this course Key Points are Handled...
  const handleChooseCourse = () => {
    let arr = [...chooseCourseArr];
    arr.push(chooseCourse);
    setChooseCourseArr(arr);
    setChooseCourse("");
  };

  //Course Image arr handled here...(temporary)
  const handleCourseImg = () => {
    if (arrOfCourseImg?.length < 2) {
      setArrOfCourseImg([...arrOfCourseImg, courseImg]);
      setCourseImg([]);
    } else {
      alert("Maximum 2 images can be added .");
    }
  };

  //Remove key points in about course section.....
  const removeKeyPoint = (each, itemIndex) => {
    const newArr = keyPointArr.filter((each, index) => {
      return index != itemIndex;
    });
    setKeyPointArr(newArr);
  };

  //Remove key points in Why choose this course section.....
  const removeCourseArr = (each, itemIndex) => {
    const newArr = chooseCourseArr.filter((each, index) => {
      return index != itemIndex;
    });
    setChooseCourseArr(newArr);
  };

  //remove course img .... (Temporary)
  const removeCourseImg = (each, itemIndex) => {
    const newArr = arrOfCourseImg.filter((each, index) => {
      return index != itemIndex;
    });
    setArrOfCourseImg(newArr);
  };

  //All Image uploads are handled here....
  const uploadImages = (eachfile, type) => {
    if (type === "Banner") {
      setloaderOne(true);
      // } else if (type === "image1") {
      //   setloaderTwo(true);
      // } else {
      //   setloaderThree(true);
    }
    const file = eachfile[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", upload_preset);
    formData.append("public_id", `KGS/${eachfile[0].name}`);
    axios
      .post(
        `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
        formData
      )
      .then((response) => {
        console.log(response);
        if (type === "Banner") {
          setCourseBannerImg(response?.data?.secure_url);
          setLoadingBnr(true);
          setloaderOne(false);
          // } else if (type === "image1") {
          //   setImageOne(response?.data?.secure_url);
          //   setLoadImageOne(true);
          //   setloaderTwo(false);
          // } else {
          //   setImageTwo(response?.data?.secure_url);
          //   setLoadImageTwo(true);
          //   setloaderThree(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Fetching current Product to edit
  const getCurrentCourse = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/courses/get-course/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("I am current course--->", response.data);
        setCurrentCourse(response.data?.course);
        setKeyPointArr(response.data?.course?.about_course?.key_points);
        setChooseCourseArr(
          response.data?.course?.about_course?.why_choose_this_course
        );
        setCourseBannerImg(response.data?.course?.courseBanner);
        // setImageOne(response.data?.course?.about_course?.images[0]);
        // setImageTwo(response.data?.course?.about_course?.images[1]);
        setLoadingBnr(true);
        setLoadImageOne(true);
        setLoadImageTwo(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //For Handling field Changes.....
  const handleInputChange = (name, value) => {
    console.log(name, value);

    if (name == "about_course") {
      setCurrentCourse((prev) => {
        return {
          ...prev,
          about_course: { ...prev.about_course, [value.field]: value.data },
        };
      });
      return;
    }

    setCurrentCourse((prev) => {
      return { ...prev, [name]: value };
    });
  };

  //All catagory is fetched over here....
  console.log("-----cat--->", category);
  const getAllCatagory = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/categories/get-all-categories`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setCategory(response?.data?.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Form Validation Handled Over here...
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    const formFields = [
      "title",
      "aboutCourseTitle",
      "mydescription",
      "ratings",
      "reviews",
      "published_by",
      "hours_of_course",
      "total_assignments",
      "video_lessons",
      "students_enrolled",
      // "key_points",
      // "images",
      // "why_choose_this_course",
      "least_details",
      "detail",
    ];

    console.log(document.getElementsByName("description")[0]);
    formFields.forEach((field) => {
      const element = document.getElementsByName(field)[0];
      if (!element || !element.value) {
        formIsValid = false;
        errors[field] = "This field is required";
      }
    });

    setFormErrors(errors);
    return formIsValid;
  };

  //Form submission handled here.....
  const createCourse = (data) => {
    const about_course = {
      title: data?.aboutCourseTitle,
      details: data?.detail,
      key_points: keyPointArr,
      // images: [imageOne, imageTwo],
      why_choose_this_course: chooseCourseArr,
      last_details: data?.least_details,
    };

    const myData = {
      ...data,
      courseBanner: courseBannerImg,
      description: data?.mydescription,
      published_by: AdminId,
      category: data?.category,
      about_course: about_course,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/courses/create`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        document.getElementById("course").reset();
        alert(
          "All images Uploaded and Course has been created successfully .."
        );
        setload(false);
        setTimeout(() => {
          navigate("/course");
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
        alert("Course Couldn't be created..!");
        setload(false);
      });
  };

  //Course Update Hnadled here
  const UpdateCourse = (e) => {
    e.preventDefault();
    setload(true);
    const myData = {
      ...currentCourse,
      courseBanner: courseBannerImg,
      published_by: AdminId,
      about_course: {
        ...currentCourse.about_course,
        key_points: keyPointArr,
        images: [imageOne, imageTwo],
        why_choose_this_course: chooseCourseArr,
      },
    };
    console.log("I am update data--->", myData);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/courses/update/${currentCourse._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response);
        document.getElementById("course").reset();
        alert("Course has been updated successfully ..");
        setload(false);
        setTimeout(() => {
          navigate("/course");
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
        alert("Course Couldn't be updated..!");
        setload(false);
      });
  };

  useEffect(() => {
    getAllCatagory();
    getCurrentCourse();
  }, []);

  //Components is returned over here...
  return (
    <form
      id="course"
      onSubmit={UpdateCourse}
      className="container mx-auto p-6 mb-6"
    >
      {/* Hero Section */}
      <div className="relative bg-gray-100 p-6 rounded-lg shadow-lg mb-8">
        <h2 className="text-2xl font-bold mb-4 text-customPurple">
          Update Course
        </h2>
        <button
          onClick={() => {
            navigate("/course");
          }}
          className="h-[2rem] absolute top-6 right-6 w-[7rem] font-semibold tracking-wide rounded-md text-white bg-customPurple hover:bg-indigo-300"
        >
          Go Back
        </button>

        <div className="flex justify-between mb-4">
          <div className="w-1/2 pr-4">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Course Name
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={currentCourse?.title}
              onChange={(e) => {
                handleInputChange("title", e.target.value);
              }}
              placeholder="Enter Course Name"
              className="border p-2 w-full rounded"
            />
          </div>

          <div className="w-1/2 pl-4">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Course Category
            </label>
            <select
              name="category"
              value={currentCourse?.category?.name}
              onChange={(e) => {
                handleInputChange("category", e.target.value);
              }}
              className="border p-2 w-full rounded"
            >
              <option value="">Select Category</option>
              {category.map((each, index) => {
                console.log("------->", currentCourse);
                return (
                  <option key={index} value={each?._id}>
                    {each?.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <label className="block text-sm font-semibold tracking-wide mb-2">
          Course Description
        </label>
        <textarea
          id="mydescription"
          name="mydescription"
          value={currentCourse?.description}
          onChange={(e) => {
            handleInputChange("description", e.target.value);
          }}
          placeholder="Enter Course Description"
          className="border p-2 w-full h-24 rounded mb-4"
        ></textarea>

        <div className="flex justify-between mb-4">
          <div className="w-1/2 pr-4">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Number of Reviews
            </label>
            <input
              type="number"
              id="reviews"
              name="reviews"
              value={currentCourse?.reviews}
              onChange={(e) => {
                handleInputChange("reviews", e.target.value);
              }}
              placeholder="Enter number of reviews"
              className="border p-2 w-full rounded"
            />
          </div>

          <div className="w-1/2 pr-4">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Rating
            </label>
            <select
              id="ratings"
              name="ratings"
              value={currentCourse?.ratings}
              onChange={(e) => {
                handleInputChange("ratings", e.target.value);
              }}
              className="border p-2 w-full rounded"
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
        </div>

        <div className="flex justify-between mb-4">
          <div className="w-1/2  lg:w-[48%] ">
            <div className="">
              <label className="block text-sm font-semibold tracking-wide mb-2">
                Course Banner
              </label>
              <input
                onChange={(e) => {
                  setLoadingBnr(false);
                  uploadImages(e.target.files, "Banner");
                }}
                type="file"
                className="border p-2 w-full rounded"
              />
            </div>
            {loadingBnr && (
              <div className="relative h-[5rem] mt-3 w-[5rem] bg-yellow-300 rounded-md">
                <img
                  className="h-full w-full object-cover rounded-md"
                  src={courseBannerImg}
                  alt="No Image"
                ></img>
                <IoCloseSharp
                  size={25}
                  color="white"
                  onClick={() => {
                    setLoadingBnr(false);
                  }}
                  className="absolute cursor-pointer  top-0 right-0"
                />
              </div>
            )}

            {loaderOne && (
              <div className="flex justify-center items-center h-[5rem] mt-3 w-[5rem] bg-yellow-300 rounded-md">
                <div className="loaderAdd"></div>
              </div>
            )}
          </div>

          {/* <div className="w-1/2 pl-4"> */}
          <p className="absolute bottom-2 right-2 block text-sm font-medium mr-4  tracking-wide mb-2">
            Published by : Admin
          </p>
          {/* <select
              id="published_by"
              name="published_by"
              {...register("published_by")}
              className="border p-2 w-full rounded"
            >
              <option value="Admin">Admin</option>
            </select> */}
          {/* </div> */}
        </div>
      </div>

      {/* Course Content */}
      <div className="bg-white p-6 rounded-lg shadow-lg mb-8">
        <h3 className="text-xl font-bold mb-4">Course Contents</h3>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="w-full ">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Hours of Course
            </label>
            <input
              type="text"
              id="hours_of_course"
              name="hours_of_course"
              value={currentCourse?.hours_of_course}
              onChange={(e) => {
                handleInputChange("hours_of_course", e.target.value);
              }}
              placeholder="Hours of Course"
              className="border p-2 rounded w-full"
            />
          </div>
          <div className="w-full ">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Total Assignments
            </label>
            <input
              type="text"
              id="total_assignments"
              name="total_assignments"
              value={currentCourse?.total_assignments}
              onChange={(e) => {
                handleInputChange("total_assignments", e.target.value);
              }}
              placeholder="Total Assignments"
              className="border p-2 rounded w-full"
            />
          </div>
          <div className="w-full">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Live Classes
            </label>
            <input
              type="text"
              id="video_lessons"
              name="video_lessons"
              value={currentCourse?.video_lessons}
              onChange={(e) => {
                handleInputChange("video_lessons", e.target.value);
              }}
              placeholder="Number of Videos"
              className="border p-2 rounded w-full"
            />
          </div>
          <div className="w-full">
            <label className="block text-sm font-semibold tracking-wide mb-2">
              Number of Students Enrolled
            </label>
            <input
              type="text"
              id="students_enrolled"
              name="students_enrolled"
              value={currentCourse?.students_enrolled}
              onChange={(e) => {
                handleInputChange("students_enrolled", e.target.value);
              }}
              placeholder="Number of Students Enrolled"
              className="border p-2 rounded w-full"
            />
          </div>
        </div>
      </div>

      {/* About Course */}
      <div className="bg-gray-100 p-6 rounded-lg shadow-lg mb-8">
        <h3 className="text-xl font-bold mb-4">About Course</h3>
        <div className="mb-4">
          <label className="block text-sm font-semibold tracking-wide mb-2">
            Course Heading
          </label>
          <input
            type="text"
            id="aboutCourseTitle"
            name="aboutCourseTitle"
            value={currentCourse?.about_course?.title}
            onChange={(e) => {
              handleInputChange("about_course", {
                field: "title",
                data: e.target.value,
              });
            }}
            className="border p-2 w-full rounded"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-semibold tracking-wide mb-2">
            More Course Details
          </label>
          <textarea
            id="detail"
            name="detail"
            value={currentCourse?.about_course?.details}
            onChange={(e) => {
              handleInputChange("about_course", {
                field: "details",
                data: e.target.value,
              });
            }}
            placeholder="More Course Details"
            className="border p-2 w-full h-24 rounded mb-4"
          ></textarea>
        </div>
        {/* <div className="flex justify-between mb-4">
          <div className="w-full">
            <div>
              <label className="block text-sm font-semibold tracking-wide mb-2">
                Image 1
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  setLoadImageOne(false);
                  uploadImages(e.target.files, "image1");
                }}
                className="border p-2 rounded"
              />
            </div>
            {loadImageOne && (
              <div className="relative h-[5rem] mt-3 w-[5rem] bg-yellow-300 rounded-md">
                <img
                  className="h-full w-full object-cover rounded-md"
                  src={imageOne}
                  alt="No Image"
                ></img>
                <IoCloseSharp
                  size={25}
                  color="white"
                  onClick={() => {
                    setLoadImageOne(false);
                  }}
                  className="absolute cursor-pointer  top-0 right-0"
                />
              </div>
            )}

            {loaderTwo && (
              <div className="flex justify-center items-center h-[5rem] mt-3 w-[5rem] bg-yellow-300 rounded-md">
                <div className="loaderAdd"></div>
              </div>
            )}
          </div>

          <div className="w-full">
            <div>
              <label className="block text-sm font-semibold tracking-wide mb-2">
                Image 2
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  setLoadImageTwo(false);
                  uploadImages(e.target.files, "image2");
                }}
                className="border p-2 rounded"
              />
            </div>
            {loadImageTwo && (
              <div className="relative h-[5rem] mt-3 w-[5rem] bg-yellow-100 rounded-md">
                <img
                  className="h-full w-full object-cover rounded-md"
                  src={imageTwo}
                  alt="No Image"
                ></img>
                <IoCloseSharp
                  size={25}
                  color="white"
                  onClick={() => {
                    setLoadImageTwo(false);
                  }}
                  className="absolute cursor-pointer  top-0 right-0"
                />
              </div>
            )}

            {loaderThree && (
              <div className="flex justify-center items-center h-[5rem] mt-3 w-[5rem] bg-yellow-300 rounded-md">
                <div className="loaderAdd"></div>
              </div>
            )}
          </div>
        </div> */}
        <div className="w-full">
          <label className="block text-sm font-semibold tracking-wide mb-2">
            Key Points About Course
          </label>

          <div className="flex items-center justify-between border rounded">
            <input
              type="text"
              id="key_points"
              name="key_points"
              value={keyPoints}
              onChange={(e) => {
                setKeyPoints(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent form submission if inside a form
                  handleKeyPointsChange();
                }
              }}
              placeholder="Key Points About Course"
              className="border-none p-2 w-full rounded"
            />
            <MdAddComment
              onClick={() => {
                handleKeyPointsChange();
              }}
              size={30}
              className="text-blue-500 mr-2 cursor-pointer "
            />
          </div>
          <div className="mt-2 rounded-lg bg-gray-50 px-2 py-2 ">
            <ul className="flex flex-wrap items-center gap-1">
              {keyPointArr?.map((each, index) => {
                return (
                  <li
                    key={index}
                    className="flex items-center gap-1 rounded-full bg-customPurple px-2 py-1 text-sm text-white"
                  >
                    {each.substring(0, 30)}
                    <IoCloseSharp
                      onClick={() => {
                        removeKeyPoint(each, index);
                      }}
                      size={20}
                      className="font-semibold cursor-pointer"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      {/* Why Choose This Course */}
      <div className="bg-white p-6 rounded-lg shadow-lg mb-8">
        <h3 className="text-xl font-bold mb-4">Why Choose This Course</h3>
        <div className="mb-4">
          <label className="block text-sm font-semibold tracking-wide mb-2">
            Key Points About Why Choose This Course
          </label>
          <div className="flex items-center justify-between border rounded">
            <input
              type="text"
              id="why_choose_this_course"
              name="why_choose_this_course"
              value={chooseCourse}
              onChange={(e) => {
                setChooseCourse(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent form submission if inside a form
                  handleChooseCourse();
                }
              }}
              placeholder="Key Points About Why Choose This Course"
              className="border-none p-2 w-full rounded"
            />
            <MdAddComment
              onClick={() => {
                handleChooseCourse();
              }}
              size={30}
              className="text-blue-500 mr-2 cursor-pointer"
            />
          </div>
          <div className="mt-2 rounded-lg bg-gray-50 px-2 py-2 ">
            <ul className="flex flex-wrap items-center gap-1">
              {chooseCourseArr?.map((each, index) => {
                return (
                  <li
                    key={index}
                    className="flex items-center gap-1 rounded-full bg-customPurple px-2 py-1 text-sm text-white"
                  >
                    {each.substring(0, 30)}
                    <IoCloseSharp
                      onClick={() => {
                        removeCourseArr(each, index);
                      }}
                      size={20}
                      className="font-semibold cursor-pointer"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-semibold tracking-wide mb-2">
            Paragraph About Why Choose This Course
          </label>
          <textarea
            id="least_details"
            name="least_details"
            value={currentCourse?.about_course?.last_details}
            onChange={(e) => {
              handleInputChange("about_course", {
                field: "last_details",
                data: e.target.value,
              });
            }}
            placeholder="Paragraph About Course"
            className="border p-2 w-full h-24 rounded mb-4"
          ></textarea>
        </div>
      </div>

      {/* submit button  */}
      <div className="col-span-2 flex justify-center">
        <button
          type="submit"
          className={`w-[12rem] px-4 py-2 ${
            load ? "bg-gray-400" : "bg-customPurple"
          }  text-white  rounded-md shadow-sm font-semibold hover:bg-indigo-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
        >
          {load ? "Updating..." : "Update Course"}
        </button>
      </div>
    </form>
  );
};

export default EditCoursePage;
